import { startAuthentication, type PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser';
import { dataFrom } from '@zyno-io/openapi-client-codegen';

import { GlobalState } from '@/global';
import { AuthLoginApi, type ILoginResponse, type IPasskeyAuthenticationOptionsResponse } from '@/openapi-clients-generated/auth';

/** Complete the browser half of a server-issued passkey authentication ceremony. */
export async function completePasskeyLogin(options: IPasskeyAuthenticationOptionsResponse, rememberMe: boolean): Promise<ILoginResponse> {
    const credential = await startAuthentication({
        optionsJSON: options.options as unknown as PublicKeyCredentialRequestOptionsJSON
    });
    return dataFrom(
        await AuthLoginApi.postLoginPasskeyVerify<true>({
            body: {
                ceremonyId: options.ceremonyId,
                credential: credential as unknown as Record<string, unknown>,
                browserId: GlobalState.browserId,
                rememberMe
            },
            credentials: 'include'
        })
    );
}

/** Starts either an account-bound or discoverable (email-less) passkey sign-in. */
export async function loginWithPasskey(email: string | undefined, rememberMe: boolean): Promise<ILoginResponse> {
    const options = dataFrom(
        await AuthLoginApi.postLoginPasskeyOptions<true>({
            body: email ? { email } : {},
            credentials: 'include'
        })
    );
    return completePasskeyLogin(options, rememberMe);
}
